import { useState } from 'react'

import type { Filter } from '../../../../store/types/product'
import Mixpanel from '../../../../utils/mixpanel/Mixpanel'

const VISIBLE_COUNT = 2

export default function SavedFilters({
  data,
  isLoading,
  onSelect,
  selectedItemId,
}: {
  data?: Filter[]
  isLoading: boolean
  onSelect: (filter: any) => void
  selectedItemId?: string | number
}): JSX.Element {
  const [showAll, setShowAll] = useState(false)

  if (isLoading || !data || data.length === 0) return <></>

  const visible = showAll ? data : data.slice(0, VISIBLE_COUNT)
  const hiddenCount = data.length - VISIBLE_COUNT

  return (
    <div className="flex flex-wrap items-center gap-2">
      {visible.map((filter) => (
        <button
          key={filter.id}
          type="button"
          onClick={() => {
            onSelect(filter)
            Mixpanel.track('Quick Filter Selected', {
              page: 'Products',
              section: 'Quick Filters',
            })
          }}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-sm font-medium transition-colors whitespace-nowrap ${
            selectedItemId === filter.id
              ? 'border-primary-400 bg-primary-50 text-primary-700'
              : 'border-gray-300 bg-white text-gray-700 hover:border-gray-400 hover:bg-gray-50'
          }`}
        >
          <span aria-hidden>📌</span>
          {filter.name}
        </button>
      ))}

      {!showAll && hiddenCount > 0 && (
        <button
          type="button"
          onClick={() => {
            setShowAll(true)
            Mixpanel.track('Show All Filters Clicked', {
              page: 'Products',
              section: 'Quick Filters',
            })
          }}
          className="text-sm text-gray-500 hover:text-gray-700 font-medium whitespace-nowrap"
        >
          + {hiddenCount} more
        </button>
      )}

      {showAll && data.length > VISIBLE_COUNT && (
        <button
          type="button"
          onClick={() => setShowAll(false)}
          className="text-sm text-gray-500 hover:text-gray-700 font-medium whitespace-nowrap"
        >
          Show less
        </button>
      )}
    </div>
  )
}
